import {ListViewProvider, useListView} from './core/ListViewProvider'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider} from './core/QueryResponseProvider'
import {CountriesListHeader} from './components/header/CountriesListHeader'
import {CountriesTable} from './table/CountriesTable'
import {CountryEditModal} from './country-edit-modal/CountryEditModal'
import {KTCard} from '../../../../_metronic/helpers'

const CountriesList = () => {
  const {itemIdForUpdate} = useListView()
  return (
    <>
      <KTCard>
        <CountriesListHeader />
        <CountriesTable />
      </KTCard>
      {itemIdForUpdate !== undefined && <CountryEditModal />}
    </>
  )
}

const CountriesListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <CountriesList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {CountriesListWrapper}
